export const GRAPH_MODAL_REQUEST = "GRAPH_MODAL_REQUEST"
export const GRAPH_MODAL_REQUEST_SUCCESS = "GRAPH_MODAL_REQUEST_SUCCESS"
export const GRAPH_MODAL_REQUEST_ERROR = "GRAPH_MODAL_REQUEST_ERROR"
